import React from "react";
import ImageOne from "../../../../assets/images/heroSection.png";
import "./heroSection.css";
import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <div className="heroSection-image-container">
      <img
        className="heroSection-image"
        src={ImageOne}
        alt="Worldwide shipping online shopping for trendy fashion outfits"
      ></img>

      <div className="heroSection-text">
        <div className="heroSection-heading">
          <h1 className="heroSection-title">Worldwide Shipping <br /> Online Shopping</h1>
        </div>

        <p className="heroSection-paragraph">
          Browse our worldwide shipping online shopping platform and discover a wide range <br /> of unique, stylish outfits for every occasion.
        </p>


        <Link to="/brands">
          <button className="heroSection-button">Shop Now</button>
        </Link>
        <div className="heroSection-status">
          <div>
            <h2>200+</h2>
            <p>International Brands</p>
          </div>

          <div>
            <h2>2000+</h2>
            <p>High-Quality Products</p>
          </div>

          <div>
            <h2>200+</h2>
            <p>Happy Customers</p>
          </div>
        </div>
      </div>
    </div>
  );
}
